<template>
  <div>
    <card>
        <h3>Dati Prestazione</h3>
        <hr>
        <form>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="causale">Causale<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="causale">
                </div>
                <div class="form-group col-md-6">
                    <label for="prestazione_professionale_fornita">Prestazione professionale fornita<span style="color:#ff0000">*</span></label>
                    <!-- <input type="text" class="form-control" v-model="prestazione_professionale_fornita"> -->
                    <select class="form-control" v-model="prestazione_professionale_fornita">
                        <option v-for="(valori, index) in prestazioni_tipo" v-bind:key="valori.ID" :value="valori.ID">{{index+1}}. {{valori.NOME}}</option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="natura">Natura<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="natura" placeholder="natura">
                </div>
                <div class="form-group col-md-6">
                    <label for="scopo">Scopo<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="scopo" placeholder="scopo">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="data_prestazione">Data Prestazione<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_prestazione">
                </div>
                <div class="form-group col-md-6">
                    <label for="data_cessazione">Data Cessazione<span style="color:#ff0000">*</span></label>
                    <input type="date" class="form-control" v-model="data_cessazione">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="modalita_pagamento">Modalità Pagamento<span style="color:#ff0000">*</span></label>
                    <select v-model="modalita_pagamento" class="form-control">
                        <option value="contanti">Contanti</option>
                        <option value="bonifico">Bonifico</option>
                        <option value="sepa">SEPA</option>
                        <option value="pos">POS</option>
                    </select>
                    <label for="metodo_importo">Modalità pagamento della fattura<span style="color:#ff0000">*</span></label>
                        <select v-model="metodo" class="form-control">
                            
                        </select>
                </div>
                <div class="form-group col-md-4">
                    <label for="divisa">Divisa<span style="color:#ff0000">*</span></label>
                    <input type="text" class="form-control" v-model="divisa">
                </div>
                <div class="form-group col-md-4">
                    <!-- <label for="importo">Importo<span style="color:#ff0000">*</span></label>
                    <input type="number" class="form-control" v-model="importo"> -->
                    <label for="importo">Importo<span style="color:#ff0000">*</span></label>
                    <div class="input-icon">
                        <!-- <input type="text" class="form-control" placeholder="0.00"> -->
                        <input type="number" class="form-control" v-model="importo" id="importo" placeholder="0.00">
                        <i>€</i>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="soggetto_per_cliente">Soggetto che opera per conto del Cliente<span style="color:#ff0000">*</span></label>
                    <select v-model="soggetto_per_cliente" class="form-control">
                        <option>...</option>
                        <option>...</option>
                    </select>
                </div>
                <div class="form-group col-md-6">
                    <label for="legame">Legame<span style="color:#ff0000">*</span></label>
                    <select v-model="legame" class="form-control">
                        <option>...</option>
                        <option>...</option>
                    </select>
                </div>
            </div>
        </form>
        
        <hr>
        <h3>Altri dati</h3>
         <div class="form-row">
            <div class="form-group col-md">
                <label for="note">Note</label>
                <textarea lass="form-control" v-model="note" id="note" rows="3" style="width:100%;border-radius:7px"></textarea>
            </div>
        </div>
        <!-- <div class="row" style="margin-top:10px;margin-left:10px">
            <span>Note:</span>
        </div>
        <div class="row" style="margin-top:10px;margin-left:10px">
            <textarea type="textarea" v-model="note" style="margin-left:5px;margin-right:5px" rows="5" cols="150"></textarea>
        </div> -->
        <button class="btn float-right" type="button" v-on:click="salvaValori()" style="margin-top:20px;margin-right:10px;background:#00467f">Salva</button>
        <router-link :to="'/prestazioni?idCliente='+idCliente" class="btn float-right" style="margin-top: 20px;margin-right:10px;background:#00467f">Indietro</router-link>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Cards/Card.vue';
import Services from '@/services/Services';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';

export default {
    components: {
        Card
    },

    data() {
        return {
            causale: null,
            prestazione_professionale_fornita: null,
            natura: null,
            scopo: null,
            data_prestazione: null,
            data_cessazione: null,
            modalita_pagamento: null,
            divisa : null,
            importo: null,
            soggetto_per_cliente: null,
            legame: null,
            note: null,

            prestazioni_tipo: [],
        }
    },
    methods: {
        getPrestazioniTipo: async function(){
            let errore = 0;
            await AntiriciclaggioServices.getPrestazioniTipo()
            .then(response => { this.prestazioni_tipo = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.getPrestazioniTipo(); }
            }
            console.log("prestazioni tipo");
            console.log(this.prestazioni_tipo);
        },

        checkData: function() {
            if ( this.causale == null || this.prestazione_professionale_fornita == null || this.natura == null ||  this.scopo == null 
                ||  this.data_prestazione == null || this.data_cessazione == null || this.modalita_pagamento == null || this.divisa == null 
                || this.importo == null || this.soggetto_per_cliente == null || this.legame == null) {
                    return false;
            } else {
                return true;
            }
        },

        salvaValori: async function() {
            if (this.checkData()) {
                let dati = [{ 
                    CAUSALE: this.causale, PRESTAZIONE_FORNITA: this.prestazione_professionale_fornita, NATURA: this.natura, SCOPO: this.scopo, 
                    DATA_PRESTAZIONE: this.data_prestazione, DATA_CESSAZIONE: this.data_cessazione, MODALITA_PAGAMENTO: this.modalita_pagamento, DIVISA: this.divisa, 
                    IMPORTO: this.importo, SOGGETTO_OPERA_CLIENTE: this.soggetto_per_cliente, LEGAME: this.legame, NOTE: this.note 
                }]
                let salvaValori = [];
                let errore = 0;
                let datiJSON=JSON.stringify(dati[0]);
                await AntiriciclaggioServices.createPrestazione(this.idCliente, datiJSON)
                .then(response => { salvaValori= response.data})
                .catch( function (error) {
                    if(error.response.status == 401){
                        errore = error.response.status;
                    }
                });
                if (errore == 401) {
                    let value = await Services.refreshTokenFunction();
                    if (value) { await this.salvaValoriDati(); }
                }
                let path = 'prestazioni?idCliente=' + this.idCliente;
                this.$router.push({
                    path: path
                }) 
            } else {
                alert("COmpilare tutti i campi!");
            }
        },
        main: async function() {
            this.idCliente = this.$route.query.idCliente;
            await this.getPrestazioniTipo();
        }
    },
    mounted() {
        this.main();
    }
};
</script>
<style scoped>
    label {
        font-size: 16px;
    }


    .input-icon {
    position: relative;
    }

    .input-icon > i {
    position: absolute;
    display: block;
    transform: translate(0, -50%);
    top: 50%;
    pointer-events: none;
    width: 25px;
    text-align: center;
        font-style: normal;
    }

    .input-icon > input {
    padding-left: 25px;
    padding-right: 0;
    }

    .input-icon-right > i {
    right: 0;
    }

    .input-icon-right > input {
    padding-left: 0;
    padding-right: 25px;
    text-align: right;
    }
</style>